import { DocumentDuplicateIcon, MinusCircleIcon } from "@heroicons/react/24/outline";
import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/table";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay, UpdateBookingCommanWay, UpdateCommanWay, UploadImageApi } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Img } from "components";
import { DataTable } from "components/DataTable/DataTable";
import { InputTable } from "components/DataTable/InputTable";
import { useFormik } from "formik";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { debounce } from "lodash";
import moment from "moment";
import { any } from "prop-types";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import handleWheel from "utils/handleOnWheel";
import { get_file_url } from "utils/lib-utils";
import Spinner from "utils/Spinner";
import { AfDataType as ADT } from "utils/TableColumnData";
import { number, object, string } from "yup";

type OptionType = {
  value: number;
  label: string;
};

interface MotherBagState {
  mode?: string;
  data?: { [key: string]: any }; // Adjust the type based on your data structure
  // Add other properties if needed
}

interface ValuesType {
  destination?: { value: string; label: string };
}

const MotherBagOutScan: React.FC = ({}) => {
  let isDisabled = false;
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;

  const [mode, setMode] = useState<any>("");

  const [mbagText, setMbagText] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isMainLoading, setIsMainLoading] = useState(false);

  const [selectedOrigin, setSelectedOrigin] = useState<any>({});
  const [selectedDest, setSelectedDest] = useState<any>({});
  const [branchList, setBranchList] = useState<any[]>([]);

  const [filterStartDt, setFilterStartDt] = useState<any>(moment().subtract(1, "day").startOf("day"));
  const [filterEndDt, setFilterEndDt] = useState<any>(moment().endOf("day"));

  const [motherBagList, setMotherBagList] = useState<any>([]);
  const [selectedMotherbag, setSelectedMotherbag] = useState<number>(null);
  const [selectedMotherbagData, setSelectedMotherbagData] = useState<any>({});
  const [motherbagStatusList, setMotherbagStatusList] = useState<any[]>([]);
  const [selectedMotherbagStatus, setSelectedMotherbagStatus] = useState<any>({ value: -1, label: "Select..." });
  const [statusFilter, setStatusFilter] = useState<any>({ value: "", label: "All" });

  const [selectedStatusValues, setSelectedStatusValues] = useState({});
  const [selectedMbagForPrint, setSelectedMbagForPrint] = useState<any>(0);

  const [modeOfPkgOptions, set_modeOfPkgOptions] = useState<any>([
    { value: 0, label: "Select Mode" },
    { value: "By Air", label: "By Air" },
    { value: "By Road", label: "By Road" },
    { value: "By Train", label: "By Train" },
  ]);
  const [airlineOptions, set_airlineOptions] = useState<any>([]);
  const [flightOptions, set_flightOptions] = useState<any>([]);
  const [vendorOptions, set_vendorOptions] = useState<any>([]);
  const [deliVendorOptions, set_deliVendorOptions] = useState<any>([]);
  const [typeOptions, set_typeOptions] = useState<any>([
    { value: 1, label: "Cargo" },
    { value: 2, label: "Console" },
  ]);

  const [userDetails, setUserDetails] = useState<any>({});

  useEffect(() => {
      const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
      if (Object.keys(userD).length) {
        setUserDetails(userD.state.user);
      }
    }, []);

  const { refetch: mbag_status } = useQuery(["MbagStatusList"], () => GetCommanWay("/admin/mbag_status_list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        console.log(data.data);
        setMotherbagStatusList(data.data);
      }
    },
  });

  useQuery(["subbranchListApi"], () => ListCommanWay("/admin/subbranch/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setBranchList(data.data.data);
      }
    },
  });

  const {
    mutate: mutateUpdateMotherBag,
    isLoading: isUpdateMotherBagloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation(
    () =>
      UpdateCommanWay({
        url: "/admin/mother_bag/update/" + selectedMotherbag,
        data: {
          outscanDone: true,
          airline: values.airline.id,
          flight: values.flight.id,
          mawb: values.mawb,
          modeOfPkg: values.modeOfPkg.value,
          realWeight: values.realWeight,
          remark: values.remark,
          /*sysWeight: values.sysWeight,
          totalNos: parseInt(values.totalNos),*/
          type: values.type.value,
          vendor: values.vendor.id,
          status: "PENDING",
          outScanPOD: true,
        },
      }),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Motherbag Outscan Complete", "success");
          resetForm();
          setSelectedMotherbag(null);
          setSelectedMotherbagData({});
          refetchData();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const { handleSubmit, handleBlur, values, handleChange, errors, setValues, setErrors, touched, dirty, setFieldValue, resetForm } =
    useFormik({
      validationSchema: object().shape({
        modeOfPkg: object().required(),
      }),
      initialValues: {
        modeOfPkg: modeOfPkgOptions[0],
        airline: { id: 0, name: "Select Airline", value: 0, label: "" },
        flight: { id: 0, name: "Select Flight", value: 0, label: "" },
        vendor: { id: 0, vendor_name: "Select Vendor", value: 0, label: "" },
        mawb: "",
        sysWeight: "",
        realWeight: "",
        totalNos: "",
        remark: "",
        type: typeOptions[0],
      },
      onSubmit: async (values, { resetForm }) => {
        console.log("======> values", values);
        if (selectedMotherbag == null) {
          UseToast("Select Motherbag !", "error");
          return;
        }
        if (values.modeOfPkg.value == 0 || !values.realWeight) {
          UseToast("Select Mode and Weights", "error");
          return;
        }
        mutateUpdateMotherBag(selectedMotherbag);
      },
    });

  useQuery(["airlineApi"], () => ListCommanWay("/admin/airline/list", {}, { paginate: 10000, include: [] }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        set_airlineOptions(data.data.data);
      }
    },
  });

  const { refetch: flightRefetch } = useQuery(
    ["flightApi"],
    () => ListCommanWay("/admin/flight/list", { airline: values.airline.id, isActive: true }, { paginate: 10000, include: [] }),
    {
      keepPreviousData: true,
      enabled: false,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_flightOptions(data.data.data);
        }
      },
    }
  );
  useEffect(() => {
    if (values.airline.id) {
      flightRefetch();
    }
  }, [values.airline.id]);

  useEffect(() => {
    if (values.airline.id) {
      setFieldValue("flight", { id: 0, name: "Select Flight", value: 0, label: "" });
    }
  }, [values.airline.id]);

  useQuery(
    ["vendorApi"],
    () =>
      ListCommanWay(
        "/admin/vendor/list",
        {
          $or: { vendorType: "Forwader", vendor_name: "OTHER" },
        },
        { paginate: 10000, include: [] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_vendorOptions(data.data.data);
        }
      },
    }
  );

  useQuery(
    ["DeliveryvendorApi"],
    () =>
      ListCommanWay(
        "/admin/vendor/list",
        {
          $or: { vendorType: "PDA", vendor_name: "OTHER" },
        },
        { paginate: 10000, include: [] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          set_deliVendorOptions(data.data.data);
        }
      },
    }
  );

  const [thirdPartyOpt, setThirdPartyOtp] = useState<any>();
  const [thirdPartyOptions, setThirdPartyOptions] = useState<any>([{ value: 0, label: "Loading..." }]);

  const { refetch: thirdPartyRefetch } = useQuery(
    ["ThirdPartyListApi"],
    () => ListCommanWay("/admin/third_party/list", {}, { paginate: 10000 }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          let opt = [];
          data.data.data.forEach((p) => {
            opt.push({
              value: p.id,
              label: p.name,
            });
          });
          setThirdPartyOptions(opt);
        }
      },
    }
  );

  const { refetch: refetchData } = useQuery(
    ["MotherBagApi"],
    () =>
      ListCommanWay(
        "/admin/mother_bag/list",
        {
          $or: {
            $and: {
              createdAt: {
                $gte: filterStartDt,
                $lte: filterEndDt,
              },
            },
          },
          subbranch: selectedOrigin?.id || undefined,
          delivery_subbranch: selectedDest?.id || undefined,
        },
        { paginate: 10000, include: ["_destination", "_subbranch", "_deliveryVendor", "_delivery_subbranch"] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setMotherBagList(data.data.data);
        }
      },
    }
  );

  const { mutate: addMotherbag_pod } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        UseToast("Motherbag Status Changed", "success");
        resetForm();
        setSelectedMotherbag(null);
        setSelectedMotherbagData({});
        setSelectedMotherbagStatus({ value: -1, label: "Select..." });
        refetchData();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      //typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });

  const getInput: any = (type, label, value, name, isDisabled, width, valueKey, labelKey) => {
    let ip = <div></div>;

    switch (type) {
      case ADT.NUMBER:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <input
              type="number"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]}
              onBlur={handleBlur}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) {
                  handleChange(e);
                }
              }}
              onWheel={handleWheel}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.TEXT:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>

            <input
              type="text"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]?.label !== undefined ? values[name]?.label : values[name]}
              onBlur={handleBlur}
              onChange={handleChange}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.DB:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <Select
              className={`${isDisabled ? "bg-gray-300" : ""} bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full `}
              options={value.all}
              onBlur={handleBlur}
              getOptionValue={(x) => (valueKey ? x[valueKey] : x.value)}
              getOptionLabel={(x) => (labelKey ? x[labelKey] : x.label)}
              onChange={(e) => {
                setFieldValue(name, e);
              }}
              name={name}
              value={values[name]}
              isDisabled={mode === "view" ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.TEXTAREA:
        break;
      case ADT.DATETIME:
        break;
      case ADT.DATE:
        ip = (
          <div className={`inline-flex items-center gap-2 ${width ? width : "w-auto"}`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">{label}</label>
            <input
              type="date"
              className={`${
                isDisabled ? "bg-gray-300" : ""
              } bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
              placeholder={label}
              name={name}
              value={values[name]}
              onBlur={handleBlur}
              onChange={handleChange}
              disabled={mode && (mode === "view" || mode === "edit") ? true : isDisabled}
            />
          </div>
        );
        break;
      case ADT.FILE:
        break;
      default:
        ip = <></>;
        break;
    }
    return ip;
  };

  const doShowRow = (m: any) => {
    switch (statusFilter.value) {
      case "":
        return true;
        break;
      case "short":
        return m.status == "SHORT";
      case "pending":
        return !m.outscanDone;
        break;
      case "outscan":
        return m.outscanDone && !m.inscanDone ? true : false;
        break;
      case "received":
        return m.status != "SHORT" && m.inscanDone ? true : false;
        break;
    }
  };

  const getModeSvg = (mode) => {
    switch (mode) {
      case "By Train":
        return (
          <svg className="bg-white p-1 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 24 24">
            \{" "}
            <path
              fill="#B8001F"
              d="M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
            />
          </svg>
        );
      case "By Road":
        return (
          <svg className="bg-gray-400 p-2 rounded-full" xmlns="http://www.w3.org/2000/svg" height="36" width="36" viewBox="0 0 48 48">
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m0 0h48v48h-48z" fill="#fff" fillOpacity=".01" />
              <g stroke="#000" strokeWidth="4" transform="translate(6 5.091863)">
                <path d="m5 .90813664-5 35.99999996" />
                <path d="m36.9287415.90813664-4.9643707 35.95523776" transform="matrix(-1 0 0 1 67.928742 0)" />
                <path d="m18 .90813664v6" />
                <path d="m18 29.9081366v7" />
                <path d="m18 14.9081366v7" />
              </g>
            </g>
          </svg>
        );
      case "By Air":
        return (
          <div className="bg-black-900 p-2 rounded-full w-9 h-9">
            <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 512 512" viewBox="0 0 512 512">
              <path
                fill="#08C2FF"
                d="m490.7 0c-21.3 0-42.7 0-53.3 10.7l-85.3 96h-330.8l-21.3 32 234.7 74.7-64 85.3h-96l-32 32 64 21.3v32c.7 11.5 10.7 21.3 21.3 21.3h32l21.3 64 32-32v-96l85.3-64 74.7 234.7 32-21.3v-330.7l96-85.3c10.7-10.7 10.7-32 10.7-53.4 0-10.6-10.7-21.3-21.3-21.3z"
              />
            </svg>
          </div>
        );
      default:
        return mode;
    }
  };

  const printLabel = (data) => {
    setSelectedMbagForPrint(data);
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);
    if (selected) {
      setPreview(URL.createObjectURL(selected));
    }
  };
  const handleLinkSlipSave = async () => {
    console.log("Text:", mbagText);
    console.log("File:", file);
    if (!mbagText) {
      alert("Please Enter MAWB No");
      return;
    }
    if (!file) {
      alert("Please Select Slip Image");
      return;
    }

    const formData = new FormData();
    formData.append("files", file);
    formData.append("folder", "image");
    setShowModal(false);
    setIsMainLoading(true);
    try {
      const response = await UploadImageApi(formData);
      console.log(response);
      if (response?.data?.uploadSuccess?.length) {
        let path = response?.data?.uploadSuccess[0].path;
        linkMotherbagSlip({
          url: "/admin/vendorslip/create/",
          data: {
            slip_url: path,
            awb_id: mbagText,
          },
        });
        setIsMainLoading(false);
      } else {
        setIsMainLoading(false);
        alert(response.data.message);
      }
    } catch (error) {
      setIsMainLoading(false);
      console.error("Error during image upload:", error);
    }
  };
  const { mutate: linkMotherbagSlip, isLoading: linkMbagLoading } = useMutation(CreateCommanWay, {
    onSuccess: (data: any) => {
      if (data.status == "SUCCESS") {
        setMbagText("");
        setFile(null);
        UseToast("Motherbag Link Successful", "success");
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      //UseToast("Motherbag Status Change error. Try Again OR Contact Admin!", "error");
    },
  });
  const linkMotherbag = (data) => {};

  const handlePrint = () => {
    let w = window.open();
    w.document.write(`<style>@page {size: 4in 4in;margin: 0.08in 0.08in 0.08in 0.16in;}</style><body style="margin: 0">${document.getElementById("mbag-slip-outer").innerHTML}</body>`);
    w.print();
    w.close();
  };

  const downloadSlipPopup = async () => {
    document.body.classList.add("inline-all-img");
    try {
      const input1 = document.getElementById("pdf-content1");
      const canvas = await html2canvas(input1);
      const imgData = canvas.toDataURL("image/png");
      document.body.classList.remove("inline-all-img");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "in",
        format: [4 * 1.25, 4 * 1.25],
      });
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save((selectedMbagForPrint?.mother_bag_code || "Mbag_Slip") + ".pdf");
    } catch {
      document.body.classList.remove("inline-all-img");
    }
  };

  const MotherBagLabel = ({ scale = 1, mdata = motherBagList?.[0] }) => {
    const s = (val) => `${val * scale}px`;

    return (
      <div
        id="pdf-content1"
        style={{
          width: s(384),
          height: s(384),
          border: `${s(2)} solid #000`,
          boxSizing: "border-box",
          padding: s(8),
          fontFamily: "sans-serif",
          position: "relative",
        }}
      >
        {false && (
          <>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, top: 0, lineHeight: 0.9 }}>⚀</span>
            <span style={{ fontSize: s(34), position: "absolute", left: 0, bottom: 0, lineHeight: 0.9 }}>⚁</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, top: 0, lineHeight: 0.9 }}>⚂</span>
            <span style={{ fontSize: s(34), position: "absolute", right: 0, bottom: 0, lineHeight: 0.9 }}>⚃</span>
          </>
        )}

        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: s(4),
          }}
        >
          <div></div>
          <div style={{ display: "flex", alignItems: "center", gap: s(10) }}>
            <span style={{ fontSize: s(36), fontWeight: "bold", lineHeight: 1 }}>DEST</span>
            <span style={{ fontSize: s(32), fontWeight: "bold", lineHeight: 1 }}>⟶</span>
            <span style={{ fontSize: s(58), fontWeight: "bold", lineHeight: 1 }}>{mdata?._delivery_subbranch?.branch_code}</span>
          </div>
        </div>

        {/* Sub Labels */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(20),
            marginBottom: s(10),
            padding: `${s(5)} 0`,
            borderTop: "1px solid black",
            borderBottom: "1px solid black",
            lineHeight: 1,
          }}
        >
          <div>
            <span>Origin Contact</span>
            <br />
            <strong style={{ display: "inline-block", marginTop: s(5) }}>{mdata?._subbranch?.mobile}</strong>
          </div>
          <div>
            <span>Dest Contact</span>
            <br />
            <strong style={{ display: "inline-block", marginTop: s(5) }}>{mdata?._deliveryVendor?.mobile_no}</strong>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: s(14),
            marginBottom: s(10),
          }}
        >
          {/* Weight and Mbag */}
          <div
            style={{
              fontSize: s(18),
              marginRight: s(5),
            }}
          >
            <div>
              <u>To,</u>
            </div>
            <div>
              <b>{mdata?._deliveryVendor?.vendor_name}</b>
            </div>
            <div>{mdata?._deliveryVendor?.office_address}</div>
          </div>

          {/* QR Code Box */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: s(4),
            }}
          >
            <QRCode value={mdata?.mother_bag_code} size={scale * 140} level="M" />
            <span style={{ fontSize: s(20), lineHeight: 1, marginTop: s(5) }}>
              <b>{mdata?.mother_bag_code}</b>
            </span>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            <Img src={"/logo.jpg"} style={{ height: s(50) }} />
          </div>
          <div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right" }}>
              Org: <strong>{mdata?._subbranch?.branch_name}</strong>
            </div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right", marginTop: s(2) }}>
              Manifested: <strong>{mdata?.totalNos || "-"}</strong>
            </div>
            <div style={{ fontSize: s(14), lineHeight: 1, textAlign: "right", marginTop: s(2) }}>
              Actual WT: <strong>{mdata?.realWeight || "-"} KG</strong>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {(isMainLoading || linkMbagLoading) && <Spinner />}

      {(selectedMbagForPrint && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-center justify-center z-50 font-inter">
          <div className="bg-white rounded-2xl shadow-lg  p-6 relative">
            {/* Close Button */}
            <button
              className="absolute top-6 right-6 text-gray-600 hover:text-black bg-gray-300 px-2 text-lg font-bold rounded-md"
              onClick={() => {
                setSelectedMbagForPrint(0);
              }}
            >
              &times;
            </button>

            {/* Title */}
            <h2 className="text-xl font-bold mb-4">Motherbag Slip</h2>

            <div className="my-4" id="mbag-slip-outer">
              <MotherBagLabel scale={1.25} mdata={selectedMbagForPrint} />
            </div>
            {/* Submit Button */}
            <div className="flex gap-4">
              <button onClick={downloadSlipPopup} type="button" className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
                Download
              </button>
              <button onClick={handlePrint} type="button" className="w-full bg-green-600 text-white py-2 rounded hover:bg-blue-700">
                Print
              </button>
            </div>
          </div>
        </div>
      )) ||
        ""}

      {showModal && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 flex items-center justify-center z-50 font-inter">
          <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-6 relative">
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-black bg-gray-300 px-2 text-lg font-bold rounded-md"
              onClick={() => {
                setShowModal(false);
              }}
            >
              &times;
            </button>

            {/* Title */}
            <h2 className="text-xl font-bold mb-4">Link MAWB Slip</h2>

            {/* Text Input */}
            <input
              type="text"
              className="w-full border rounded px-3 py-2 mb-4 focus:border-gray-500"
              placeholder="Enter Airfield Motherbag No"
              value={mbagText}
              onChange={(e) => setMbagText(e.target.value)}
            />

            <hr />

            {/* File Input */}
            <input type="file" accept="image/*" className="mb-4 mt-2" onChange={handleFileChange} />

            {/* Image Preview */}
            {preview && <img src={preview} alt="Preview" className="w-full max-h-64 object-contain mb-4 border rounded" />}

            {/* Submit Button */}
            <button onClick={handleLinkSlipSave} className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700">
              Submit
            </button>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between font-inter mt-2 mb-4 mx-4">
        <h1 className="text-2xl font-black px-2 py-1 underline">Mother Bag Out Scan</h1>

        <div className="flex items-center justify-center gap-3">
          {userDetails.roleName == "Admin" && <>
          <div className={` items-center gap-2 w-48`}>
            <label className="mb-2 text-sm font-semibold text-gray-900">Origin</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-0`}
              options={branchList}
              isClearable={true}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.branch_name;
              }}
              onChange={(e: any) => {
                setSelectedOrigin(e);
              }}
            />
          </div>
          <div className={` items-center gap-2 w-48`}>
            <label className="text-sm font-semibold text-gray-900">Destination</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-0`}
              options={branchList}
              isClearable={true}
              getOptionValue={(e: any) => {
                return e.id;
              }}
              getOptionLabel={(e: any) => {
                return e.branch_name;
              }}
              onChange={(e: any) => {
                setSelectedDest(e);
              }}
            />
          </div></>}

          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-900">From</label>
            <input
              type="date"
              className="focus:border-colors2 rounded"
              value={filterStartDt.format("YYYY-MM-DD")}
              onChange={(e: any) => {
                setFilterStartDt(moment(e.target.value).startOf("day"));
              }}
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-semibold text-gray-900">To</label>
            <input
              type="date"
              className="focus:border-colors2 rounded"
              value={filterEndDt.format("YYYY-MM-DD")}
              onChange={(e: any) => {
                setFilterEndDt(moment(e.target.value).endOf("day"));
              }}
            />
          </div>

          <Button
            type="button"
            className="rounded-md px-2 py-2.5 text-sm font-medium text-white bg-blue-500 border hover:bg-opacity-60 focus:z-10"
            onClick={refetchData}
          >
            Search
          </Button>

          <div className="w-36 ml-10">
            <Select
              className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
              options={[
                { value: "", label: "All" },
                { value: "pending", label: "Pending" },
                { value: "outscan", label: "Outscan" },
                { value: "short", label: "Short" },
                { value: "received", label: "Received" },
              ]}
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e);
              }}
              menuPortalTarget={document.body}
            />
          </div>
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(e);
        }}
        className="font-"
      >
        <div className="px-6">
          <table className="border text-left px-4 rounded">
            <thead className="border-b">
              <tr>
                <th className="py-2 px-2 print:hidden">-</th>
                <th className="px-1">Added On</th>
                <th className="px-1">Motherbag No</th>
                <th className="px-1">Origin</th>
                <th className="px-1">Destination</th>
                <th className="px-1">Mode</th>
                <th className="px-1">
                  No of
                  <br />
                  Awb
                </th>
                <th className="px-1">Total Weight</th>
                <th className="px-1">Status</th>
                <th className="px-1 print:hidden">Action</th>
                <th className="px-1 print:hidden">Last Reason</th>
                <th className="px-1 print:hidden">Reason</th>
              </tr>
            </thead>
            <tbody>
              {motherBagList.map((m) => {
                return (
                  doShowRow(m) && (
                    <tr
                      key={"tr-" + m.id}
                      className={`border-t ${m.id == selectedMotherbag && "bg-blue-200"} 
                    ${
                      m.status == "SHORT"
                        ? "bg-teal-600 text-white"
                        : m.inscanDone
                        ? "bg-green-500"
                        : m.outscanDone
                        ? "bg-yellow-100"
                        : "bg-red-400"
                    }`}
                    >
                      <td className="print:hidden">
                        {m.outscanDone ? (
                          <p className="py-1 px-1 text-sm">-</p>
                        ) : m.id == selectedMotherbag ? (
                          <p className="py-1 px-1 text-sm">Selcted</p>
                        ) : (
                          <>
                            <Button
                              type="button"
                              className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                              onClick={() => {
                                setSelectedMotherbag(m.id);
                                setSelectedMotherbagData(m);
                                resetForm();
                              }}
                            >
                              Select
                            </Button>

                            {!m.outscanDone && (
                              <Button
                                type="button"
                                className="rounded-md px-2 py-1 text-sm font-medium text-white bg-blue-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 ml-2"
                                onClick={() => {
                                  navigate("/mother_bag/add", {
                                    state: {
                                      mode: "edit",
                                      data: m,
                                    },
                                  });
                                }}
                              >
                                Edit
                              </Button>
                            )}
                          </>
                        )}
                      </td>
                      <td>{moment(m.createdAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")}</td>
                      <td className="px-2 whitespace-nowrap">
                        <button
                          type="button"
                          onClick={async () => {
                            await navigator.clipboard.writeText(m.mother_bag_code || "-");
                            UseToast("Copied!");
                          }}
                        >
                          <DocumentDuplicateIcon className="h-5 -mb-1 mr-2" />
                        </button>
                        <span
                          className="cursor-pointer hover:underline font-semibold font-opensans"
                          onClick={() => {
                            navigate("/mother_bag/add", {
                              state: {
                                mode: "view",
                                data: m,
                              },
                            });
                          }}
                        >
                          {m.mother_bag_code}
                        </span>
                      </td>
                      <td>{m._subbranch?.branch_name}</td>
                      <td>{m._delivery_subbranch?.branch_name || m._destination?.city_name}</td>
                      <td>{getModeSvg(m.modeOfPkg)}</td>
                      <td>{m.totalNos}</td>
                      <td>{Number(m.sysWeight).toFixed(2)}</td>
                      <td>{m.status == "SHORT" ? "Short" : m.inscanDone ? "Received" : m.outscanDone ? "Outscan" : "Pending"}</td>
                      <td className="text-center print:hidden whitespace-nowrap px-2">
                        {!m?.VendorSlips?.length ? (
                          <button
                            type="button"
                            className="inline-block rounded-md px-2 py-1 text-sm font-medium border border-gray-200 focus:z-10 bg-gray-400 text-gray-600 mr-1"
                            onClick={() => {
                              setMbagText(m.mother_bag_code || "");
                              setShowModal(true);
                            }}
                          >
                            Link
                          </button>
                        ) : (
                          <a
                            href={(m?.VendorSlips?.length && get_file_url(m?.VendorSlips[m?.VendorSlips?.length - 1].slip_url)) || ""}
                            target="_blank"
                            className={`inline-block rounded-md px-2 py-1 text-sm font-medium bg-black-900 border border-gray-200 focus:z-10 mr-1 ${
                              !m?.VendorSlips?.length ? "bg-gray-400 text-gray-600" : "text-white hover:bg-opacity-60"
                            }`}
                          >
                            Slip
                          </a>
                        )}
                        <Button
                          type="button"
                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-black-900 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                          onClick={() => printLabel(m)}
                        >
                          Print
                        </Button>
                      </td>
                      <td>{m.motherbad_pods && m.motherbad_pods.length > 0 && m.motherbad_pods[0].remark}</td>
                      <td className="flex p-1 gap-1 max-w-[300px] print:hidden">
                        <Select
                          className={`flex-1 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block `}
                          options={motherbagStatusList}
                          value={selectedStatusValues[m.id] || ""}
                          onChange={(e) => {
                            setSelectedMotherbagStatus(e);
                            setSelectedStatusValues((prevState) => ({
                              ...prevState,
                              [m.id]: e,
                            }));
                          }}
                          styles={{
                            control: (provided, state) => ({
                              ...provided,
                              minHeight: "30px",
                              height: "30px",
                            }),
                            valueContainer: (provided, state) => ({
                              ...provided,
                              height: "30px",
                              padding: "0 6px",
                            }),
                            input: (provided, state) => ({
                              ...provided,
                              margin: "0px",
                            }),

                            indicatorsContainer: (provided, state) => ({
                              ...provided,
                              height: "30px",
                            }),
                          }}
                          menuPortalTarget={document.body}
                        />
                        <Button
                          type="button"
                          className="rounded-md px-2 py-1 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
                          onClick={() => {
                            selectedStatusValues[m.id].value != -1 &&
                              addMotherbag_pod({
                                url: "/admin/motherbad_pod/create/",
                                data: {
                                  bagId: m.id,
                                  status: selectedStatusValues[m.id].value + "",
                                  remark: selectedStatusValues[m.id].label,
                                  dateTime: new Date(),
                                },
                              });
                          }}
                        >
                          Save
                        </Button>
                      </td>
                    </tr>
                  )
                );
              })}
            </tbody>
          </table>

          <div className="flex gap-2 flex-wrap border p-2 rounded-xl mt-4">
            <div className="w-full font-semibold underline">Motherbag Information</div>

            <div className="grid grid-cols-3 w-full mt-3">
              {getInput(ADT.DB, "Mode Of Package", { all: modeOfPkgOptions }, "modeOfPkg", isDisabled, "border-x border-[#000] px-2")}

              {getInput(ADT.DB, "Airline", { all: airlineOptions }, "airline", isDisabled, "border-x border-[#000] px-2", "id", "name")}

              {getInput(ADT.DB, "Flight", { all: flightOptions }, "flight", isDisabled, "border-x border-[#000] px-2", "id", "name")}

              {getInput(ADT.DB, "Vendor", { all: vendorOptions }, "vendor", isDisabled, "border-x border-[#000] px-2", "id", "vendor_name")}

              {false &&
                getInput(
                  ADT.DB,
                  "Delivery Vendor",
                  { all: deliVendorOptions },
                  "deliveryVendor",
                  isDisabled,
                  "border-x border-[#000] px-2",
                  "id",
                  "vendor_name"
                )}

              {getInput(ADT.TEXT, "MAWB_No", {}, "mawb", isDisabled, "border-x border-[#000] px-2")}

              {getInput(ADT.DB, "Type", { all: typeOptions }, "type", isDisabled, "border-x border-[#000] px-2")}
              {/*getInput(
                ADT.TEXT,
                "Weight",
                selectedMotherbagData.totalNos,
                "sysWeight",
                isDisabled,
                "border-x border-[#000] px-2"
              )*/}

              {getInput(ADT.TEXT, "Actual Weight", {}, "realWeight", isDisabled, "border-x border-[#000] px-2")}

              {/*getInput(
                ADT.TEXT,
                "Total Pieces",
                {},
                "totalNos",
                true,
                "border-x border-[#000] px-2"
              )*/}

              {getInput(ADT.TEXT, "Remark", {}, "remark", isDisabled, "border-x border-[#000] px-2")}

              <button
                type="button"
                className="text-lg font-semibold bg-primary text-white px-4 py-1 rounded-md m-2"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                Link MAWB Slip
              </button>
            </div>
            <div className="flex w-full justify-end">
              <Button
                type="submit"
                className="rounded-md inline-block px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-gray-200 hover:bg-opacity-60 focus:z-10 "
              >
                Outscan
              </Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default MotherBagOutScan;
